import { createAction } from '@reduxjs/toolkit';

export const clearEnquiry = createAction('ENQUIRY/CLEAR_ENQUIRY');
export const createEnquiry = createAction('ENQUIRY/CREATE_ENQUIRY');
export const setEnquiry = createAction('ENQUIRY/SET_ENQUIRY');
export const clearCallbackRequest = createAction('ENQUIRY/CLEAR_CALLBACK_REQUEST');
export const createCallbackRequest = createAction('ENQUIRY/CREATE_CALLBACK_REQUEST');
export const setCallbackRequest = createAction('ENQUIRY/SET_CALLBACK_REQUEST');
